import axios from 'axios';
import { getConfiguration, ENDPOINTS } from './config';
import { GetTestInfo } from './test';
import { getMsToken } from '../helper/studentMetadata';

export const getUrl = (endpoint) => {
    const BASE_URL = getConfiguration().apiUrl;
    return BASE_URL + 'api/' + endpoint + '/';
};

export const createAPIEndpoint = endpoint => {

    if (getConfiguration().enableTestWS) {
        if (endpoint === ENDPOINTS.getInformation) {

            return {
                fetchById: (id) => {
                    function isPromise(value) { return value instanceof Promise; }

                    const testInfo = GetTestInfo(id);
                    if (isPromise(testInfo)) return testInfo;

                    const promise = new Promise((resolve) => {
                        resolve({ data: testInfo });
                    });

                    return promise;
                }
            };
        }
    }

    let url = getUrl(endpoint);
    let token = getMsToken();
    axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

    return {
        fetch: () => axios.get(url),
        fetchById: id => axios.get(url + id),
        post: newRecord => axios.post(url, newRecord, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        put: (id, updatedRecord) => axios.put(url + id, updatedRecord),
        delete: id => axios.delete(url + id),
    }
}

export class PortalError extends Error {
    constructor(number, message) {
        super(message);
        this.number = number
    }
}

export const windowOpen = (url) => {
    window.open(url, isUserFromApp() ? '_self' : '_blank');
};

export const isUserFromApp = () => {
    const token = getMsToken();
    return token?.endsWith("_MiRedAliat");
};

const openPdfViewer = (params) => {
    let pdfparams = JSON.stringify(params);
    if (isUserFromApp()) {
        windowOpen("plantillas/pdfdownloader.html?pdfparams=" + encodeURI(pdfparams));
    }
    else {
        window.document.pdfparams = pdfparams;
        windowOpen("plantillas/pdfdownloader.html");
    }
};

export const getPaymentSSO = (planAcademico) => {

    const request = {
        Matricula: planAcademico.matricula,
    }

    return createAPIEndpoint(ENDPOINTS.getPaymentSSO)
        .post(request)
        .then(res => {
            if (!res || !res.data || res.data.length === 0) {
                throw new PortalError("005", "Ocurrio un error al establecer la relacion de confianza con el portal de pagos. Por favor intenta nuevamente.<br /><br />Si el problema persiste contacta al administrador del sistema");
            }

            return res.data;
        });
};

export const getPaymentReference = (planAcademico) => {

    const params = {
        url: getUrl(ENDPOINTS.getPaymentReference),
        token: `bearer ${getMsToken()} `,
        isUserFromApp: isUserFromApp(),
        data: {
            Matricula: planAcademico.matricula,
            Institucion: planAcademico.institucion,
            Campus: planAcademico.campus,
            Grado: planAcademico.grado,
            NumeroGrado: planAcademico.numerodegrado,
            Programa: planAcademico.programaacademico,
            Plan: planAcademico.planacademico,
        }
    };

    openPdfViewer(params);
};


export const getSchedule = (planAcademico) => {

    const params = {
        url: getUrl(ENDPOINTS.getSchedule),
        token: `bearer ${getMsToken()} `,
        isUserFromApp: isUserFromApp(),
        data: {
            emplid: planAcademico.matricula,
            institution: planAcademico.institucion,
            campus: planAcademico.campus,
            acad_prog: planAcademico.programaacademico,
            acad_career: planAcademico.grado,
            strm: planAcademico.cclinscripcion,
            acad_plan: planAcademico.planacademico,
            stdnt_car_nbr: planAcademico.numerodegrado.toString()
        }
    };

    openPdfViewer(params);
}

export function setStorageWithExpiry(key, value) {
    const ttl = 1000 * 60 * 1;  //Establece un valor con una expiraci�n de 1 minutos
    const now = new Date();

    // `item` es un objeto que contiene el valor y la hora de expiraci�n
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

export function getStorageWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // si el elemento no existe, retorna null
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compara la hora actual con la hora de expiraci�n del item
    if (now.getTime() > item.expiry) {
        // Si la fecha de expiraci�n ya pas�, elimina el item del localStorage
        // y retorna null
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

export function setStorage(key, value) {
    // `item` es un objeto que contiene el valor y la hora de expiraci�n
    const item = {
        value: value,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

export function getStorage(key) {
    const itemStr = localStorage.getItem(key);
    // si el elemento no existe, retorna null
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    return item.value;
}
